import { InternalHeader } from "./components";
import { useSelector } from "react-redux";
import { getMetadata } from "@/features/metadata/metadataSlice";
import { isMobile } from "@/helpers/utils";
import { useEffect, useState } from "react";
// import styles from "@/assets/Home.module.scss";

export const HeaderSection = () => {
  const metadata = useSelector(getMetadata);
  const superAppFlag = metadata?.appName === "SUPER_APP";
  const [mobileView, setMobileView] = useState(false);

  useEffect(() => {
    setMobileView(isMobile(window.innerWidth));
  }, []);

  return (
    <>
      {(!superAppFlag || (superAppFlag && !mobileView)) && (
        <div>
          <div className="container">
            <InternalHeader />
          </div>
        </div>
      )}
    </>
  );
};
